import { useEffect, useState } from "react";
import { Loader2, RotateCcw } from "lucide-react";

export function CodeInput({ value, onChange, testId = "code-input" }) {
  return (
    <input value={value} onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" autoComplete="one-time-code" pattern="\d{6}" maxLength={6}
      placeholder="000000" className="ga-input w-full text-center text-2xl tracking-[0.5em]" aria-label="Código de 6 dígitos" data-testid={testId} />
  );
}

export function ResendButton({ onResend, cooldown = 60, testId = "code-resend" }) {
  const [left, setLeft] = useState(cooldown);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (left <= 0) return; const t = setTimeout(() => setLeft(left - 1), 1000); return () => clearTimeout(t); }, [left]);
  const go = async () => { setBusy(true); try { await onResend(); setLeft(cooldown); } finally { setBusy(false); } };
  return (
    <button type="button" onClick={go} disabled={left > 0 || busy} className="ga-muted flex w-full items-center justify-center gap-1 text-xs disabled:opacity-50" data-testid={testId}>
      {busy ? <Loader2 size={12} className="animate-spin" /> : <RotateCcw size={12} />} {left > 0 ? `Reenviar código em ${left}s` : "Reenviar código"}
    </button>
  );
}
